// 计算联合光度

export default class CalcJointSphCyl {
    sph: number;
    cyl: number;
    transCyl: number;
    constructor(sph: number, cyl: number) {
        this.sph = sph ? parseFloat(sph.toString()) : 0;
        this.sph = this.sph * 100;
        this.cyl = cyl ? parseFloat(cyl.toString()) : 0;
        this.cyl = this.cyl * 100;
        // 散光转化为负数
        this.transCyl = this.cyl / 100;
    }
    // 转化后的sph
    get transSph() {
        return this.sph / 100;
    }
    // 联合光度
    get unitLumi() {
        let { transSph, transCyl } = this;
        transSph = transSph * 100;
        transCyl = transCyl * 100;
        // 散光为正，就不做判断了
        // 有一个为0则是异号
        if (transSph * transCyl > 0) {
            return (transCyl + transSph) / 100;
        } else if (
            transSph * transCyl <= 0 &&
            Math.abs(transSph) > Math.abs(transCyl)
        ) {
            return transSph / 100;
        } else if (
            transSph * transCyl <= 0 &&
            Math.abs(transSph) <= Math.abs(transCyl)
        ) {
            //混散，无联合光度
            return false;
        } else {
            throw new Error("some sph cyl calc error");
        }
    }
}
